
import moment from 'moment'
import { mapState, mapMutations, mapActions } from 'vuex'

import Icon from '../Icon'

export default {
  name: 'SingleProduct',
  components: {
    Icon,
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placement: {
      type: String,
      default: 'menu',
      validator: (value) => {
        return ['menu', 'catering', 'order'].includes(value)
      }
    },
    quickAddOnly: {
      type: Boolean,
      default: false,
    },
    showAvailableDescription: {
      type: Boolean,
      default: false,
    },

  },
  data() {
    return {
      pizzaCategories: [
        'Build Your Own',
        'Whirled Famous Pizzas',
        'Flying Stix'
      ]
    }
  },
  computed: {
    ...mapState(['location', 'appInfo', 'cart', 'menu', 'isUpsellsView', 'isUpsellsModalView', 'channel']),
    ...mapState({
      currentProduct: state => state.product
    }),
    placeholderImage() {
      return this.appInfo.order['placeholder_image']
    },
    imgSrc() {
      if (this.data.images && this.data.images['marketplace-product']) {
        return this.data.images['marketplace-product'].url
      }
      if (this.data.images && this.data.images.default) {
        return this.data.images.default.url
      }
      if (this.data.image && this.data.image.filename) {
        return this.data.image.filename
      }
      return ''
    },
    isPizza() {
      return this.pizzaCategories.includes(this.data.category)
    },
    productName() {
      if (this.appInfo.menu?.product_card?.capitalize_name) {
        return this.$utils.capitalize(this.data.name)
      }
      return this.data.name
    },
    isCheckoutPage() {
      return this.$route.fullPath.includes('checkout')
    },
    showChips() {
      return this.appInfo.menu?.product_card?.show_product_chips
    },
    showPriceChip() {
      return this.appInfo.menu?.product_card?.show_product_chips.price
        && this.data.cost
        && this.data.cost > 0
    },
    showNutritionChip() {
      return this.appInfo.menu?.product_card?.show_product_chips.calories
        && this.data.nutrition?.calories?.base
    },
    showNutritionContains() {
      return this.appInfo.menu?.product_card?.show_product_chips.nutrition_contains
    },
    showNutritionLifestyle() {
      return this.appInfo.menu?.product_card?.show_product_chips.nutrition_lifestyle
    },
    customizeBtnStyle() {
      return this.appInfo.menu?.product_card?.cta_style?.customize || 'small black outline'
    },
    isQuickAdd() {
      return this.data.quickadd || this.data['quick-add'] || this.data['quick_add']
    },
    quickAddBtnStyle() {
      return this.appInfo.menu?.product_card?.cta_style?.quick_add || 'btn small'
    },
    customizeBtnLabelAlone() {
      return this.appInfo.menu?.product_card?.cta_label?.customize_alone || 'Customize'
    },
    customizeBtnLabelGroup() {
      return this.appInfo.menu?.product_card?.cta_label?.customize_group || 'Customize'
    },
    quickAddBtnLabelAlone() {
      return this.appInfo.menu?.product_card?.cta_label?.quick_add_alone || 'Add'
    },
    quickAddBtnLabelGroup() {
      return this.appInfo.menu?.product_card?.cta_label?.quick_add_group || 'Add'
    },
    customizeBtnIconAlone() {
      return this.appInfo.menu?.product_card?.cta_icon?.customize_alone || ''
    },
    customizeBtnIconGroup() {
      return this.appInfo.menu?.product_card?.cta_icon?.customize_group || ''
    },
    quickAddBtnIconAlone() {
      return this.appInfo.menu?.product_card?.cta_icon?.quick_add_alone || 'plus-icon'
    },
    quickAddBtnIconGroup() {
      return this.appInfo.menu?.product_card?.cta_icon?.quick_add_group || 'plus-icon'
    },
    nutritionContains() {
      if (this.data['nutrition_contains']) {
        let nutriArray = this.data['nutrition_contains'].split(',')
        nutriArray = nutriArray.map(item => {
          item = item.replace(/ /g, '')
          item = this.$utils.kebab(item)

          return `contain-${item}-icon`
        })

        return nutriArray
      }

      return []
    }
  },
  methods: {
    ...mapMutations(['setErrors', 'setIsUpsellsModalView']),
    ...mapMutations({
      setSelectedProd: 'product/setSelectedProd'
    }),
    ...mapActions(['hideCart', 'viewCart', 'trackEvent', 'selfUpsellsView', 'selfUpsellsModalView']),
    ...mapActions({
      quickAddProduct: 'product/quickAddProduct',
    }),
    customize(data) {
      document.body.style.overflow = 'auto'
      this.hideCart();

      const category = this.menu.categories.find((c) => c.name === data.category) || {}

      if (data.available?.from && data.available?.till) {
        let cartTime = this.cart?.time?.mode === 'advance' ? this.cart.time.wanted : this.cart?.time?.earliest ? this.cart?.time?.earliest : moment().format('YYYYMMDD hh:mm')
        let from = moment(cartTime, 'YYYYMMDD hh:mm').format('YYYYMMDD ') + data.available.from
        let till = moment(cartTime, 'YYYYMMDD hh:mm').format('YYYYMMDD ') + data.available.till

        if (moment(cartTime, 'YYYYMMDD hh:mm').isAfter(moment(from, 'YYYYMMDD hh:mm')) && moment(cartTime, 'YYYYMMDD hh:mm').isBefore(moment(till, 'YYYYMMDD hh:mm'))) {
          this.setSelectedProd(true)
          this.$router.push(`/${this.placement}/${this.location.menu_id}/product/${this.data.id}`)
        } else {
          this.setSelectedProd(false)
          this.setErrors([`${data.name} is only available from ${moment(from, 'YYYYMMDD hh:mm').format('h:mma')} to ${moment(till, 'YYYYMMDD hh:mm').format('h:mma')}. Please udpate your order time to order this product.`])
        }

      } else {
        this.setSelectedProd(true)
        this.$router.push(`/${this.placement}/${this.location.menu_id}/product/${this.data.id}`)
      }
    },
    async quickAdd() {
      const resp = await this.quickAddProduct(this.data)
      if (resp && !this.isCheckoutPage) {
        document.body.style.overflow = 'hidden'
        this.viewCart(this.data)
      }

      // If it's in the Self Upsell view then hide and show the cart
      if (this.isUpsellsView) {
        this.selfUpsellsView(false)
      } else if (this.isUpsellsModalView) {
        this.selfUpsellsModalView(false)
        this.scrollToBottom()
        // After scrolling, highlight the last added product
        setTimeout(() => {
          this.highlightLastProduct();
        }, 500);
      }
    },

    scrollToBottom() {
      console.log('scrolled')
      // Select the element with the 'cart-container' class
      const cartContainer = document.querySelector('.cart-container');
      if (cartContainer) {
        // Smoothly scroll to the bottom of the container
        cartContainer.scrollTo({
          top: cartContainer.scrollHeight, // Get the total height of the container
          behavior: 'smooth'
        });
      }
    },

    highlightLastProduct() {
      // Select all elements with the 'cart-product' class
      const cartProducts = document.querySelectorAll('.cart-product');
      if (cartProducts.length > 0) {
        // Get the last added product
        const lastProduct = cartProducts[cartProducts.length - 1];
        // Add the highlight class
        lastProduct.classList.add('highlight');
        // Remove the highlight class after 2 seconds
        setTimeout(() => {
          lastProduct.classList.remove('highlight');
        }, 2000);
      }
    },

    showAvailabilityMessage(data) {
      return false

      // they removed the breakfast menu for now
      // QU specific
      if (data.from && data.till) {
        let cartTime = this.cart?.time?.mode === 'advance' ? this.cart.time.wanted : this.cart?.time?.earliest ? this.cart?.time?.earliest : moment().format('YYYYMMDD hh:mm')
        let from = moment(cartTime, 'YYYYMMDD hh:mm').format('YYYYMMDD ') + data.from
        let till = moment(cartTime, 'YYYYMMDD hh:mm').format('YYYYMMDD ') + data.till

        if (moment(cartTime, 'YYYYMMDD hh:mm').isAfter(moment(from, 'YYYYMMDD hh:mm')) && moment(cartTime, 'YYYYMMDD hh:mm').isBefore(moment(till, 'YYYYMMDD hh:mm'))) {
          return false
        }
      }

      return true
    },
    availabilityMessage(data) {
      return `Available from ${moment(data.from, 'hh:mm').format('h:mma')} to ${moment(data.till, 'hh:mm').format('h:mma')}`
    }
  }
}
